module.exports = __webpack_public_path__ + "static/social-network-cover-bcd375f2e1fb096963e45fd34ddcaffc.png";